import { relationships } from "@rocicorp/zero";
import { crew } from "./crew";
import { plan } from "./plan";
import { user } from "./user";
import { userAssignment } from "./user-assignment";

export const userAssignmentRelationships = relationships(userAssignment, ({ one }) => ({
	crew: one({
		sourceField: ["crewId"],
		destField: ["id"],
		destSchema: crew,
	}),
	plan: one({
		sourceField: ["planId"],
		destField: ["id"],
		destSchema: plan,
	}),
	user: one({
		sourceField: ["userId"],
		destField: ["id"],
		destSchema: user,
	}),
}));
